import { Injectable } from '@angular/core';

const LAYOUT_ENDPOINT = '/layout';

@Injectable()
export class LayoutService {
  constructor() {}
}
